import { formatDate, parseDate } from 'builder/utils/formatDate'

export const getPhrase = (sessions: number) => (sessions > 1 ? 'sessions' : 'session')

export const getPackageValidity = (expirationDate: string) => {
  if (!expirationDate) {
    return
  }

  const isExpired = parseDate(expirationDate) < new Date()
  return `, ${isExpired ? 'expired on' : 'valid until'} ${formatDate(
    expirationDate,
    'MMMM do, yyyy',
  )}`
}
